const headerFilterSection = document.querySelector('.section-header--filter')

window.onscroll = function () {
	if (window.pageYOffset > headerFilterSection.offsetTop) {
		headerFilterSection.classList.add('stikcy-header--filter');
	} else {
		headerFilterSection.classList.remove('stikcy-header--filter');
	}
}

//  category selector

const outerCatgoryFilter = document.querySelectorAll('.inner-catg--togler')
const innerCatgoryFilter = document.querySelector('.inner-catg-filters--wrapper')
const iconFiltersWrapperOverlay = document.querySelector('#iconFiltersWrapper-Overlay')
const filterPopUP = document.getElementById('popUp-all-filter--wrapper')

// intaily setting the active pop ups to null

let currentActive = ''

function classListToggle(toggleCurrentActive) {
	toggleCurrentActive.classList.toggle('active')
	document.body.classList.toggle('overflow-hidden')
	iconFiltersWrapperOverlay.classList.toggle('active')
}

outerCatgoryFilter.forEach((CatgoryFilter) => {
	CatgoryFilter.addEventListener('click', () => {
		classListToggle(innerCatgoryFilter)
		currentActive = innerCatgoryFilter
	})
})
// function called inline 
function openPopUpFilter() {
	classListToggle(filterPopUP);
	document.body.classList.toggle('overflow-hidden')
	currentActive = filterPopUP;
}

iconFiltersWrapperOverlay.addEventListener('click', () => {
	classListToggle(currentActive)
})


// sub category selector 
prevHighlightCategory = null
prevHighlightSubCategory = null
prevHighlightInnerCategory = null

const Observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			const highlightCategory = document.querySelector('.category-' + entry.target.dataset.parent);
			const highlightSubCategory = document.querySelector('.sub-category-' + entry.target.dataset.category);
			const highlightInnerCategory = document.querySelector('.inner-catg--' + entry.target.dataset.parent);
            
            highlightSubCategory?.classList.add('active')
            highlightCategory.classList.add('active')
           
          
			if (prevHighlightCategory !== null && prevHighlightCategory !== highlightCategory) {
				prevHighlightCategory.classList.remove('active')
			}

              highlightInnerCategory.classList.add('active')

             if (prevHighlightInnerCategory !== null && prevHighlightInnerCategory !== highlightInnerCategory) {
				prevHighlightInnerCategory.classList.remove('active')
			}
          
			if (prevHighlightSubCategory !== null && prevHighlightSubCategory !== highlightSubCategory) {
				prevHighlightSubCategory.classList.remove('active')
			}
			prevHighlightSubCategory = highlightSubCategory;
            prevHighlightCategory = highlightCategory;
            prevHighlightInnerCategory = highlightInnerCategory;
		}
	})
})


prevHighlightCategory = document.querySelector('.outer-catg-filter.active')
prevHighlightSubCategory = document.querySelector('.sub-catg.active')

const headers = document.querySelectorAll('.category_subheader')

headers.forEach((section) => {
	Observer.observe(section)
})

const urlObj = new URL(window.location.href);
  // Get the value of the 'macros' parameter
  const macrosValue = urlObj.searchParams.get('macros');
let headerFilter = macrosValue || 'all'
const appliedFilters = []
const rangeFilter = []
const nutritionFilter = []
const proteinFilter = []
const dietaryFilter = []


const applyPopUpFilter = new CustomEvent('applyPopUpFilter');

//header icon filters 
let prevfilter = document.querySelector('.active-filter');
class IconFiterSelector extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', () => this.mainFiterSelector(this));


    var search = location.search.substring(1);
    const params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

    console.log('cdebug', this.dataset.filter, params.macros);

    if(this.dataset?.filter == params?.macros) {
      this.click();
    }
	}
	mainFiterSelector(filter) {   
		if (prevfilter.classList.contains('active-filter')) {
			prevfilter.classList.remove('active-filter');
			prevfilter = this;
			this.classList.add('active-filter');
      headerFilter  = this.dataset.filter;
      document.dispatchEvent(applyPopUpFilter);
      this.updateUrl(headerFilter)
		}
	}

  updateUrl(headerFilter) {
    const url = new URL(window.location.href);
    if (url.searchParams.has('macros')) {
      // Update the value of the headerFilter parameter
      url.searchParams.set('macros', headerFilter);
    } else {
      // Add the headerFilter parameter with the new value
      url.searchParams.append('macros', headerFilter);
    }
    history.pushState({}, '', url.toString());
  }
}
customElements.define('icon-filter-selector', IconFiterSelector);


function inputFilter(checkbox , filterType) {
  const index = filterType.indexOf(checkbox.name);
	if (checkbox.checked && !filterType.includes(checkbox.name) ) {
		filterType.push(checkbox.name)
        appliedFilters.push(checkbox.name)
	} else {
		filterType.splice(index, 1);
		appliedFilters.splice(index, 1);
	}
	document.dispatchEvent(applyPopUpFilter);

  console.log(filterType , 'range and filetr')
}


function sortEneblur(type, ascending, numaric) {
	const changeSortOption = new CustomEvent('changeSortOption', {
       detail: {
      type: type,
      ascending: ascending,
      numaric: numaric,
      }
     })
	document.dispatchEvent(changeSortOption);
}
// collection category 


class collectionCategory extends HTMLElement {
	constructor() {
		super();
        
		this.products = this.querySelectorAll('.grid__item');
		this.productLiArray = Array.from(this.products);
		document.addEventListener('applyPopUpFilter', () => this.appliedFilter());
		document.addEventListener('changeSortOption', () => {
          this.appliedSort( event.detail.type, this, event.detail.numaric, event.detail.ascending )
        });
		this.productsShown = ''
	}

 connectedCallback() {
    this.appliedFilter()
  }


	appliedFilter() {
      this.products = this.querySelectorAll('.grid__item');
	  let removedItemCount = 0;
      let removedByType = 0
      this.products.forEach((listItem) => {
      const hasHeaderFilter = listItem.dataset.range.includes(headerFilter);
      const hasRangeFilter = rangeFilter.some(function(range) {return listItem.dataset.range.includes(range);});
      const hasProteinFilter = proteinFilter.some(function(protein) {return listItem.dataset.range.includes(protein);});
      const hasDietaryFilter = dietaryFilter.some(function(dietary) {return listItem.dataset.range.includes(dietary);});
      const hasNutritionFilter = nutritionFilter.every(function(nutrition) {return listItem.dataset.range.includes(nutrition);});


      if (rangeFilter.length < 1 &&  nutritionFilter.length < 1) {
        if (hasHeaderFilter) {
            listItem.classList.remove('not-matching-with-applied--filters');
          } else {
            listItem.classList.add('not-matching-with-applied--filters');
            removedItemCount++;
          }
      }
      else if (rangeFilter.length > 1 &&  nutritionFilter.length < 1) {
         if (hasHeaderFilter && hasRangeFilter) {
            listItem.classList.remove('not-matching-with-applied--filters');
          } else {
            listItem.classList.add('not-matching-with-applied--filters');
            removedItemCount++;
          }
      }
      else if ( hasNutritionFilter && rangeFilter.length < 1   ) {
         if (hasHeaderFilter && hasNutritionFilter) {
            listItem.classList.remove('not-matching-with-applied--filters');
          } else {
            listItem.classList.add('not-matching-with-applied--filters');
            removedItemCount++;
          }
      }
      else{
        if (hasHeaderFilter && hasRangeFilter && hasNutritionFilter ) {
            listItem.classList.remove('not-matching-with-applied--filters');
          } else {
            listItem.classList.add('not-matching-with-applied--filters');
            removedItemCount++;
          }
      }

     if (proteinFilter.length > 0  ) {
       if (hasHeaderFilter &&  hasProteinFilter ) {
            listItem.classList.remove('not-matching-with-protien-type');
          } else {
            listItem.classList.add('not-matching-with-protien-type');
         removedByType++
          }
     }
    else if (dietaryFilter.length > 0 ) {
      if (hasHeaderFilter &&  hasDietaryFilter ) {
            listItem.classList.remove('not-matching-with-protien-type');
          } else {
            listItem.classList.add('not-matching-with-protien-type');
         removedByType++
          }
    }
    else{
      if (hasHeaderFilter  ) {
            listItem.classList.remove('not-matching-with-protien-type');
          } else {
            listItem.classList.add('not-matching-with-protien-type');
        removedByType++
          }
    }

      });

		if (removedItemCount == this.products.length  ) {
			this.classList.add('hidden')
			this.previousElementSibling.classList.add('hidden')
            document.getElementsByClassName(this.previousElementSibling.id)[0]?.classList.add('hidden')
		} else if (this.products.length == removedByType ) {
			this.classList.add('hidden')
			this.previousElementSibling.classList.add('hidden')
            document.getElementsByClassName(this.previousElementSibling.id)[0]?.classList.add('hidden')
		} else {
			this.classList.remove('hidden')
			this.previousElementSibling.classList.remove('hidden')
            document.getElementsByClassName(this.previousElementSibling.id)[0]?.classList.remove('hidden')
		}
	}

	appliedSort(attribute, container, isNumeric, isDescending) {
     console.log('order', isDescending)

    const itemsArray = Array.from(this.products);

    itemsArray.sort((a, b) => {
      const aValue = isNumeric ? parseFloat(a.dataset[attribute]) : a.dataset[attribute];
      const bValue = isNumeric ? parseFloat(b.dataset[attribute]) : b.dataset[attribute];      
      if (!isDescending) {
        return aValue > bValue ? -1 : 1;
      } else {
        return aValue < bValue ? -1 : 1;
      }
    });

    itemsArray.forEach((item) => container.appendChild(item));
  }
}

customElements.define('collection-category', collectionCategory);

// collection category wrapper , to hide if all categories are hidden

class collectionCategoryWrapper extends HTMLElement {
  constructor() {
    super();
         this.categories = this.querySelectorAll('collection-category')
         document.addEventListener('applyPopUpFilter', () => this.checkForAllCategories(this));
     }
   checkForAllCategories(mainCat) {
    let removedCatCount = 0;
    this.categories.forEach((category)=>{
      if (category.classList.contains('hidden')) {
        removedCatCount++
      }
      })
      this.categories.length == removedCatCount ? mainCat.classList.add('hidden') : mainCat.classList.remove('hidden');
  }
 }
 customElements.define('collection-category-wrapper', collectionCategoryWrapper )


// sort option 

const sortPopUp = document.querySelector('#popUp-sort-options--wrapper');

function openPopUpSort() {
	sortPopUp.classList.toggle('active');
	document.body.classList.toggle('overflow-hidden')
}

document.addEventListener('applyPopUpFilter', () => {
   window.scrollTo(0, 0)
  const emptyCollectionMsg = document.querySelector('.empty-collection');
  const allCategory = document.querySelectorAll('collection-category-wrapper');
  let removedWrapperCount = 0;
    allCategory.forEach((wrapper, index)=>{
      if (wrapper.classList.contains('hidden')) {
        removedWrapperCount++
      }
 })
  if (removedWrapperCount === allCategory.length) {
     emptyCollectionMsg.classList.remove('hidden')
  } else {
    emptyCollectionMsg.classList.add('hidden')
  }
});

 const clearFilterBtn = document.getElementById('clear-filter--btn')

clearFilterBtn.addEventListener('click', ()=>{

  console.log(appliedFilters)
    appliedFilters.forEach((filterLabel) => {
    setTimeout(() => {
       document.querySelector('.' + filterLabel)?.click()
    }, 30);
  });

})
